import { useEffect, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import UserContext from '../store/User/UserContext';
import UserRoles from '../components/Profile/UserRoles';
import Container from '../components/Layout/Container';

const Profile = () => {
    const { t } = useTranslation();
    const user = useContext(UserContext);
    const [userRoles, setUserRoles] = useState([]);

    useEffect(() => {
        if (user) {
            const roles = [];

            if (user.role.admin) roles.push(t('role.admin'));
            if (user.role.idp) roles.push(t('role.idp'));
            if (user.role.manager) roles.push(t('role.manager'));
            if (user.role.teamleiter) roles.push(t('role.teamLead'));
            if (user.role.agent) roles.push(t('role.agent'));

            setUserRoles(roles);
        }
    }, [user, setUserRoles, t]);

    return (
        <Container>
            <Grid container spacing={1}>
                {!user && <div>TELEFONICA CALLMART</div>}
                {user && (
                    <>
                        <Grid item xs={12}>
                            <Typography>
                                {t('field.name')}: <span className="notranslate">{user.name}</span>
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>
                                {t('field.email')}: <span className="notranslate">{user.email}</span>
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>
                                {t('field.location')}: <span className="notranslate">{user.primaryLocation.city}</span>
                            </Typography>
                        </Grid>
                        <UserRoles roles={userRoles} />
                    </>
                )}
            </Grid>
        </Container>
    );
};

export default Profile;
